import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { AuthService } from '../authentication/auth.service';
import { DialogService } from '../dialogs/dialogs.service';
import { SplashService } from '../splash/splash.service';

@Injectable()
export class ErrorService {
    constructor(private authService: AuthService, private dialogService: DialogService, private splashService: SplashService) {}

    // #region Handle Service Error Service Call

    HandleServiceError(error: any) {
        const self = this;
        let status: number = null;
        let msg: string = null;

        if (error instanceof HttpErrorResponse) {
            status = error.status;

            const body = error && error.error;
            msg = body.ExceptionMessage || body.Message || (typeof body === 'string' ? body : 'An unknown error has occurred.');
        } else {
            let errorPacket = error.message || error;

            if (errorPacket != null && errorPacket !== '' && errorPacket[0] === '{') {
                errorPacket = JSON.parse(errorPacket);
            }
            msg =
                errorPacket != null && errorPacket instanceof Object
                    ? errorPacket.ExceptionMessage || errorPacket.Message || error
                    : errorPacket || 'An unknown error has occurred.';
        }

        this.splashService.CloseSplash();

        if (status === 401 && msg === 'No current session.') {
            // This is an Unauthorized response, indicating the user's session has expired. Allow them a chance to
            // reauthorize/login via dialog.
            this.dialogService
                .OpenInputBoxDialog({
                    TitleText: 'Session Expired',
                    MessageText:
                        `Your current session to the DELTA System has expired. In order to continue using the ` +
                        `DELTA System, please login to the system using the password box shown below. Your current page/work ` +
                        `will not be disrupted by this re-login.`,
                    OKText: 'Login Again',
                    CancelText: 'Cancel - Logout',
                    AsPassword: true,
                })
                .subscribe(password => {
                    if (password != null) {
                        // Attempt to login again using the supplied password.
                        self.authService.TimeoutLogin(password).subscribe(
                            loggedIn => {
                                if (loggedIn === true) {
                                    self.splashService.SnackbarSuccess('Login Successful. Active Session Restored.');
                                } else {
                                    self.HandleServiceError('Login Unsuccessful. Unable to continue current DELTA session.');
                                }
                            },
                            _error => {
                                self.HandleServiceError(_error);
                            }
                        );
                    } else {
                        // User has opted to not continue. Logout as a DB timeout.
                        self.authService.Logout(false, 2);
                    }
                });
        } else {
            // Something else, which should be snackbar displayed.
            this.splashService.SnackbarError(msg, 8000);
        }
    }

    // #endregion

    // #region Retrieve Service Error Service Call

    RetrieveServiceError(error: any) {
        let status: number = null;
        let msg: string = null;

        if (error instanceof HttpErrorResponse) {
            status = error.status;

            const body = error && error.error;
            msg = body || (typeof body === 'string' ? body : 'An unknown error has occurred.');
        } else {
            let errorPacket = error.message || error;
            if (errorPacket != null && errorPacket !== '') {
                errorPacket = JSON.parse(errorPacket);
            }
            msg =
                errorPacket != null && errorPacket instanceof Object
                    ? errorPacket.ExceptionMessage || errorPacket.Message || error
                    : errorPacket || 'An unknown error has occurred.';
        }

        if (status === 408) {
            // This is a Request Timeout response, indicating the user's session has expired.
            msg = 'Your current session to the STARS System has timed out and is no longer valid.';
        }

        return msg;
    }

    // #endregion
}



// WEBPACK FOOTER //
// ./src/services/error/error.service.ts